import { Skeleton, Box } from '@chakra-ui/react';
import React from 'react';

import { useGetActiveRailzConnectionsByOrgIdQuery } from '../../requests/financialData.gql.generated';
import { RailzConnectionTable } from './RailzConnectionTable';
import { RailzConnectButton } from './RailzConnectModal';

export const RailzConnectContainer = ({
  organizationId,
}: {
  organizationId: string;
}) => {
  const { data: railzConnections } = useGetActiveRailzConnectionsByOrgIdQuery({
    variables: { organizationId },
  });

  if (!railzConnections) {
    return <Skeleton h="600px" />;
  }

  return (
    <Box id="railz-connect-container">
      <RailzConnectButton organizationId={organizationId} />

      {railzConnections.connections.length > 0 && (
        <Box mt="5">
          <RailzConnectionTable connections={railzConnections.connections} />
        </Box>
      )}
    </Box>
  );
};
